import { useChainId, useChains } from 'wagmi'

import { Chain } from '../types'
import { useNetworkChange } from './useNetworkChange'
import { getChainConfigEntry } from '@/config/chain'
import { useSandbox } from '@/domain/sandbox/useSandbox'

export interface UseSelectNetworkDialogParams {
  closeDialog: () => void
}

export interface UseSelectNetworkDialogResult {
  chains: Chain[]
}

export function useSelectNetworkDialog({ closeDialog }: UseSelectNetworkDialogParams): UseSelectNetworkDialogResult {
  const currentChainId = useChainId()
  const { sandboxChainId } = useSandbox()
  const supportedChainIds = useChains()
    .map((chain) => chain.id)
    .filter((chainId) => chainId !== sandboxChainId)
  const { changeNetwork, isPending, variables } = useNetworkChange({
    onSuccess: () => {
      closeDialog()
    },
  })

  // Appending sandbox if not in sandbox mode, moving sandbox to the end if in sandbox mode
  const chains: Chain[] = [...supportedChainIds, ...(sandboxChainId ? [sandboxChainId] : [])].map((chainId) => {
    const config = getChainConfigEntry(chainId)

    return {
      name: config.meta.name,
      logo: config.meta.logo,
      selected: chainId === currentChainId,
      isInSwitchingProcess: isPending && variables === chainId,
      onSelect: () => {
        if (chainId === currentChainId) {
          closeDialog()
          return
        }

        changeNetwork(chainId)
      },
    }
  })

  return {
    chains,
  }
}
